import { CALLAPI_REJECT_REASON, withCallAPI } from '01_core/components/system/CallAPI';
import { withRouter } from '01_core/components/system/CustomRouter';
import { LOGININFO, STATUS } from '01_core/constants/APIs';
import { LABEL } from '01_core/constants/labelConsts';
import { STRING_CONSTS } from '01_core/constants/stringConsts';
import { TYPES_FONT, coreFontActions } from '01_core/reducers/coreFontActions';
import { INFOBAR_VARIANT, TYPES_INFO_BAR, coreInfoBarActions } from '01_core/reducers/coreInfoBarActions';
import { TYPES_LOCALE, coreLocaleActions, DEFAULT_LANGUAGE, VALID_LANGUAGES } from '01_core/reducers/coreLocaleActions';
import { TYPES_LOGIN_INFO, coreLoginInfoActions } from '01_core/reducers/coreLoginInfoActions';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';

const LoginInfoLoader = (props) => {
  const {
    callAPI,
    sessionId,
    openInfoBar,
    intl,
    history,
    setContactUs,
    setPrivacyPolicy,
    setCode,
    setMenuData,
    setMenuLabel,
    setLanguage,
    setSystemSettings,
    setLoginUser,
    setSystemLink,
    setDocumentLink,
    setMailFlg,
    setFontsize,
    removeSessionId,
    children,
  } = props;

  const [loadComplete, setLoadComplete] = React.useState(false);

  React.useEffect(() => {
    const setupLoginInfo = async () => {
      if (!sessionId) {
        // ログイン前はここでの遷移を抑止
        return;
      }

      try {
        const result = await callAPI(LOGININFO);
        if (result.status === STATUS.SUCCESS) {
          setContactUs(result.contactUs);
          setPrivacyPolicy(result.privacypolicy);
          setCode(result.code);
          setMenuData(result.menuData);
          setMenuLabel(result.menuLabel);
          const lang = VALID_LANGUAGES.indexOf(result.locale) === -1 ? DEFAULT_LANGUAGE : result.locale;
          setLanguage(lang);
          setSystemSettings(result.config);
          setLoginUser(result.loginUser);
          setSystemLink(result.systemLink);
          setDocumentLink(result.documentLink);
          setMailFlg(result.mailFlg);
          setFontsize(result.fontsize);
          setLoadComplete(true);
        } else {
          removeSessionId();
          history.push(STRING_CONSTS.ROOT_PATH);
        }
      } catch (e) {
        if (e.reason !== CALLAPI_REJECT_REASON.CALLING) {
          removeSessionId();
          openInfoBar(INFOBAR_VARIANT.ERROR, intl.formatMessage({ id: LABEL.CORE_SYSTEM_ERROR_MESSAGE }));
          history.push(STRING_CONSTS.ROOT_PATH);
        }
      }
    };

    setupLoginInfo();
  }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loadComplete) {
    return children;
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        background: '#efeff0',
        position: 'fixed',
        zIndex: -1,
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  sessionId: state.coreLoginInfo.sessionId,
});

const mapDispatchToProps = (dispatch) => ({
  openInfoBar: (type, message) => dispatch(coreInfoBarActions[TYPES_INFO_BAR.OPEN](type, message)),
  setSessionId: (sessionId) => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_SESSION_ID](sessionId)),
  removeSessionId: () => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.REMOVE_SESSION_ID]()),
  setContactUs: (contents) => dispatch(coreLocaleActions[TYPES_LOCALE.SET_CONTACT_US](contents)),
  setPrivacyPolicy: (contents) => dispatch(coreLocaleActions[TYPES_LOCALE.SET_PRIVACY_POLICY](contents)),
  setLanguage: (lang) => dispatch(coreLocaleActions[TYPES_LOCALE.SET_LANGUAGE](lang)),
  setCode: (code) => dispatch(coreLocaleActions[TYPES_LOCALE.SET_CODE](code)),
  setMenuLabel: (menuLabel) => dispatch(coreLocaleActions[TYPES_LOCALE.SET_MENU_LABEL](menuLabel)),
  setMenuData: (menuData) => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_MENU_DATA](menuData)),
  setSystemSettings: (systemSettings) =>
    dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_SYSTEM_SETTINGS](systemSettings)),
  setLoginUser: (loginUser) => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_LOGIN_USER](loginUser)),
  setSystemLink: (systemLink) => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_SYSTEM_LINK](systemLink)),
  setDocumentLink: (documentLink) => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_DOCUMENT_LINK](documentLink)),
  setMailFlg: (mailFlg) => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_MAIL_FLG](mailFlg)),
  setFontsize: (fontsizeCd) => dispatch(coreFontActions[TYPES_FONT.SET_FONTSIZE](fontsizeCd)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(injectIntl(withCallAPI(LoginInfoLoader))));